var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Clipboard50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 98",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d4e1f4",
    d: "M79.6,26.1V83.4a6,6,0,0,1-6,6H24.4a6,6,0,0,1-6-6V26.1a6,6,0,0,1,6-6h9.8v7H63.7v-7h9.9A6,6,0,0,1,79.6,26.1Z",
    "data-name": "<Path>"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00ceb4",
    d: "M63.7,20.1v7H34.2V14.6h7.3a7.6,7.6,0,0,1,7.4-6,7.5,7.5,0,0,1,7.4,6h7.4Z",
    "data-name": "<Path>"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#083863",
    d: "M73.6,18H66V14.6c0-1.1-1.2-1.6-2.3-1.6H57.8a9,9,0,0,0-8.9-6A9.1,9.1,0,0,0,40,13H34.2c-1.1,0-2.2.5-2.2,1.6V18H24.4A8.5,8.5,0,0,0,16,26.1V83.4c0,4.4,4,7.6,8.4,7.6H73.6C78,91,82,87.8,82,83.4V26.1A8.5,8.5,0,0,0,73.6,18ZM36,17h5.5a2.1,2.1,0,0,0,1.9-1.8,5.8,5.8,0,0,1,5.5-4.5,5.7,5.7,0,0,1,5.4,4.5,2.2,2.2,0,0,0,2,1.8H62v8H36ZM78,83.4c0,2.2-2.2,3.6-4.4,3.6H24.4c-2.2,0-4.4-1.4-4.4-3.6V26.1A4.5,4.5,0,0,1,24.4,22H32v5.1A2.1,2.1,0,0,0,34.2,29H63.7A2.2,2.2,0,0,0,66,27.1V22h7.6A4.5,4.5,0,0,1,78,26.1Z",
    "data-name": "<Compound Path>"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#083863",
    d: "M32.1,62.5a1.8,1.8,0,0,1-1.4-.6l-4.1-4.2a2.1,2.1,0,0,1,0-2.9,2,2,0,0,1,2.8.1l2.7,2.8,6.4-6.1a2,2,0,0,1,2.8.1,1.9,1.9,0,0,1,0,2.8l-7.8,7.4A2,2,0,0,1,32.1,62.5Z",
    "data-name": "<Path>"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#083863",
    d: "M70,60H47a2,2,0,0,1,0-4H70a2,2,0,0,1,0,4Z",
    "data-name": "<Path>"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#083863",
    d: "M32.1,46.5a1.8,1.8,0,0,1-1.4-.6l-4.1-4.2a2.1,2.1,0,0,1,0-2.9,2,2,0,0,1,2.8.1l2.7,2.8,6.4-6.1a2,2,0,0,1,2.8.1,1.9,1.9,0,0,1,0,2.8l-7.8,7.4A2,2,0,0,1,32.1,46.5Z",
    "data-name": "<Path>"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#083863",
    d: "M70,44H47a2,2,0,0,1,0-4H70a2,2,0,0,1,0,4Z",
    "data-name": "<Path>"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#083863",
    d: "M32.1,78.5a1.8,1.8,0,0,1-1.4-.6l-4.1-4.2a2.1,2.1,0,0,1,0-2.9,2,2,0,0,1,2.8.1l2.7,2.8,6.4-6.1a2,2,0,0,1,2.8.1,1.9,1.9,0,0,1,0,2.8l-7.8,7.4A2,2,0,0,1,32.1,78.5Z",
    "data-name": "<Path>"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#083863",
    d: "M70,76H47a2,2,0,0,1,0-4H70a2,2,0,0,1,0,4Z",
    "data-name": "<Path>"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Clipboard50);
export default __webpack_public_path__ + "static/media/icons8-clipboard-50.2bc4541ca8cfccd673df3f785835190b.svg";
export { ForwardRef as ReactComponent };